module.exports = __webpack_public_path__ + "static/media/bg-ship.c36b77d0.svg";